import React from "react";
import { withTranslation } from "react-i18next";
import { Tab, Segment, Header, Icon, Button } from "semantic-ui-react";
import ConfirmButton from "../controls/confirmButton";
import { Map, Marker, TileLayer } from "react-leaflet";
import L from "leaflet";
// eslint-disable-next-line 
import LCG from "leaflet-control-geocoder";
import 'leaflet-draw/dist/leaflet.draw.css';
import 'leaflet-draw';


class EditPosition extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isDrawing: false,
		};
		this.leafletMap=null;
		this.handleDrawStart = this.handleDrawStart.bind(this);
   		this.handleDrawStop = this.handleDrawStop.bind(this);
	}


	handleDrawStart(e) {
		this.setState({ isDrawing: true });
		console.log('entered');
	  }
	
	  handleDrawStop(e) {
		this.setState({ isDrawing: false });
		console.log('entered 2');
	  }

	componentDidMount() {
		if (!this.props.edit.state.data.editable) return;
		setTimeout(() => {
			try {
			const map = this.leafletMap.leafletElement;

			this.leafletMap = this.leafletMap.leafletElement;
			
			this.leafletMap.on('draw:drawstart', this.handleDrawStart);
			this.leafletMap.on('draw:drawstop', this.handleDrawStop);


			const geocoder = L.Control.geocoder({
				defaultMarkGeocode: false,
				collapsed: false,
				placeholder: this.props.t("geocoder.placeholder"),
				errorMessage: this.props.t("geocoder.error"),
				iconLabel: this.props.t("geocoder.iconLabel"),
				showResultIcon: true,
			})
				.on("markgeocode", (e) => {
					geocoder.setQuery("");
					this.props.data.changePosition(
						{ lat: e.geocode.center.lat, lng: e.geocode.center.lng },
						Math.min(19, map.getBoundsZoom(e.geocode.bbox))
					);
				})
				.addTo(map);

			const drawnItems = new L.FeatureGroup();
			map.addLayer(drawnItems);
					

			const drawControl = new L.Control.Draw({
				draw: {
					polygon: {
						allowIntersection: false,
						showArea: true,
						shapeOptions: {
						  color: 'blue',
						},
					  },
					  // All others disabled
					  circle: false,
					  rectangle: false,
					  polyline: false,
					  marker: false,
					  circlemarker: false,
					 
				},
				
				edit: {
					featureGroup: drawnItems,
				},
			});
			
			L.drawLocal = { 
				draw: {
				  toolbar: {
					// #TODO: this should be reorganized where actions are nested in actions
					// ex: actions.undo  or actions.cancel
					actions: {
					  title: this.props.t("geofence.cancel_drawing"),
					  text: this.props.t("geofence.cancel")
					},
					finish: {
					  title: this.props.t("geofence.finish_drawing"),
					  text: this.props.t("geofence.finish")
					},
					undo: {
					  title: this.props.t("geofence.delete_last_point_drawn"),
					  text: this.props.t("geofence.delete_last_point")
					},
					buttons: {
					  polygon: this.props.t("geofence.draw_a_polygon"),
					}
				  },
				  handlers: {
					circle: {
					  tooltip: {
						start: this.props.t("geofence.click_to_start_drawing_shape")
					  },
					  radius: 'Radius'
					},
					circlemarker: {
					  tooltip: {
						start: this.props.t("geofence.click_to_start_drawing_shape")
					  }
					},
					marker: {
					  tooltip: {
						start: this.props.t("geofence.click_first_point_to_close_this_shape")
					  }
					},
					polygon: {
					  tooltip: {
						start: this.props.t("geofence.click_to_continue_drawing_shape"),
						cont: this.props.t("geofence.click_to_continue_drawing_shape"),
						end: this.props.t("geofence.click_first_point_to_close_this_shape")
					  }
					},
					polyline: {
					  error: '<strong>Error:</strong> shape edges cannot cross!',
					  tooltip: {
						start: 'Click to start drawing line.',
						cont: 'Click to continue drawing line.',
						end: 'Click last point to finish line.'
					  }
					},
					rectangle: {
					  tooltip: {
						start: 'Click and drag to draw rectangle.'
					  }
					},
					simpleshape: {
					  tooltip: {
						end: 'Release mouse to finish drawing.'
					  }
					}
				  }
				},
				edit: {
				  toolbar: {
					actions: {
					  save: {
						title: this.props.t("geofence.save_changes"),
						text: this.props.t("geofence.save")
					  },
					  cancel: {
						title: this.props.t("geofence.cancel_editing"),
						text:  this.props.t("geofence.cancel")
					  },
					  clearAll: {
						title: this.props.t("geofence.clear_all_layers"),
						text: this.props.t("geofence.clear_all_layers")
					  }
					},
					buttons: {
					  edit: this.props.t("geofence.edit_layers"),
					  editDisabled: this.props.t("geofence.no_layers_to_edit"),
					  remove: this.props.t("geofence.delete_layers"),
					  removeDisabled: this.props.t("geofence.no_layers_to_delete")
					}
				  },
				  handlers: {
					edit: {
					  tooltip: {
						text: this.props.t("geofence.drag_handles"),
						subtext: this.props.t("geofence.click_cancel")
					  }
					},
					remove: {
					  tooltip: {
						text: this.props.t("geofence.Click_feature_remove")
					  }
					}
				  }
				}
			  };
		
			map.addControl(drawControl);	
			map.on(L.Draw.Event.CREATED, (event) => {
				const layer = event.layer;
				drawnItems.addLayer(layer);
		
				 if (event.layerType === 'polygon') {
				  const latlngs = layer.getLatLngs();
				  console.log('Polygon:', latlngs);
				  this.props.data.changeGeoFence(latlngs);
				// console.log(this.props.edit.state.data,'dataaaaaa');
				}
			  });
			if (this.props.edit.state.data.geofence) {
				const polygonDecode=JSON.parse(this.props.edit.state.data.geofence);
				const polygon = L.polygon(polygonDecode, { color: 'blue' });
				drawnItems.addLayer(polygon);
			}  

			map.on(L.Draw.Event.EDITED, (event) => {
			const layers = event.layers;
				layers.eachLayer((layer) => {
					if (layer instanceof L.Polygon) {
					const updatedLatlngs = layer.getLatLngs();
					this.props.data.changeGeoFence(updatedLatlngs);
					console.log(this.props.edit.state.data,'dataaaaaaedit');
					}
				});
			});

			map.on(L.Draw.Event.DELETED, (event) => {
				event.layers.eachLayer((layer) => {
					this.props.data.changeGeoFence("");
					console.log(this.props.edit.state.data,'dataaaaaa');
				});
			});

				

			} catch(e){}
		}, 100);
	}



	render() {
				const statePos = this.props.global
			? this.props.edit.state.data.position
			: this.props.data.state.formData.position;

		if (!this.props.global && !statePos) {
			return (
				<Tab.Pane>
					<Segment placeholder>
						<Header icon>
							<Icon name="calendar times outline" />
							{this.props.t("edit.difference.header", {
								type: this.props.t("edit.difference.types.positions"),
							})}
							<Header.Subheader>
								{this.props.t("edit.difference.message", {
									type: this.props.t("edit.difference.types.positions"),
								})}
							</Header.Subheader>
						</Header>
						<ConfirmButton
							trigger={
								<Button negative>
									{this.props.t("edit.difference.action", {
										type: this.props.t("edit.difference.types.positions"),
									})}
								</Button>
							}
							onClick={() =>
								this.props.data.changePosition({ lat: 0, lng: 0 }, 0)
							}
						/>
					</Segment>
				</Tab.Pane>
			);
		}

		let position;
		let zoom;

		if (
			statePos &&
			statePos.lat !== 0 &&
			statePos.lng !== 0 &&
			statePos.zoom !== 0
		) {
			position = [statePos.lat, statePos.lng];
			zoom = statePos.zoom;
		} else if (
			!this.props.global &&
			this.props.edit.state.data.position &&
			this.props.edit.state.data.position.lat !== 0 &&
			this.props.edit.state.data.position.lng !== 0 &&
			this.props.edit.state.data.position.zoom !== 0
		) {
			position = [
				this.props.edit.state.data.position.lat,
				this.props.edit.state.data.position.lng,
			];
			zoom = this.props.edit.state.data.position.zoom;
		} else {
			position = [
				this.props.t("stdPos.lat", 50.8),
				this.props.t("stdPos.lng", 10.5),
			];
			zoom = this.props.t("stdPos.zoom", 6);
		}


		return (
			<Tab.Pane className="mapTab">
				<Map
					center={position}
					zoom={zoom}
					ref={(m) => {
						this.leafletMap = m;
					}}
					onClick={(e) => {
						if (this.state.isDrawing) {
							// e.originalEvent.stopPropagation(); // Prevents interaction while drawing
							return;
						}
						if((!this.props.global &&
							!!this.props.data.state.formData.bpo.length) ||
						!this.props.edit.state.data.editable) {
							return;
						}else{
							
							this.props.data.changePosition(e.latlng, e.target.getZoom())
						}
						// (!this.props.global &&
						// 	!!this.props.data.state.formData.bpo.length) ||
						// !this.props.edit.state.data.editable
						// 	? null
						// 	: (e) =>
						// 			this.props.data.changePosition(e.latlng, e.target.getZoom())
					}}
				>
					<TileLayer url="https://maps.bpo-asphalt.de/tile.php?z={z}&x={x}&y={y}&key=dboth&type=standard" />

					<Marker
						position={position}
						draggable={
							this.props.edit.state.data.editable &&
							(this.props.global || !this.props.data.state.formData.bpo.length)
						}
						onDragEnd={(e) =>
							this.props.data.changePosition(
								e.target.getLatLng(),
								e.target._map.getZoom()
							)
						}
					/>
				</Map>
			</Tab.Pane>
		);
	}
}

export default withTranslation()(EditPosition);
